import React, { useEffect, useState } from "react";
import {
    Dialog,
    Classes,
    Icon,
    Intent
} from "@blueprintjs/core";
import { GET, TenantID } from "../dataSaver";
import { useNavigate } from "react-router-dom";
import style from "./index.module.scss";
import CommonSelectField from "../../Components/CommonFields/CommonSelectField";
import { ErrorToaster } from "../../utils/toaster";
import { fetchEntityDetails } from "../../utils/generalConfig";

const AddSiteSelectionPopup = ({
    show,
    handleClose,
    handleSelectedSite,
    reminderType,
    isSaveConfirmation = false,
    selectedSite: initialSelectedSite
}) => {
    console.log('Current reminderType:', reminderType);

    const [entityData, setEntityData] = useState();
    const [selectedSite, setSelectedSite] = useState({ id: '0' });
    const navigate = useNavigate();
    const isMultiSiteEntity = sessionStorage.getItem("isMultiSiteEntity") === "true";
    useEffect(() => {
        if (show) {
            if (isSaveConfirmation && initialSelectedSite) {
                setSelectedSite(initialSelectedSite);
            } else {
                getEntityData();
                setSelectedSite({ id: '0' });
            }
        }
    }, [show, isSaveConfirmation, initialSelectedSite]);

    const getEntityData = async () => {
        try {
            // Get all sites
            const entity = await fetchEntityDetails({ tenantId: TenantID });

            // Get existing alerts for the reminderType
            const { data: alertsData } = await GET(
                `timesheet-management-service/reminder?reminderType=${reminderType}&tenantId=${TenantID}&offset=0&limit=100`
            );

            // Get array of site IDs that already have alerts
            const configuredSiteIds = alertsData?.reminderData?.map(reminder =>
                reminder.site?.id
            ).filter(Boolean) || [];

            // Filter out sites that already have alerts configured
            const filteredSites = entity?.sites?.filter(site =>
                !configuredSiteIds.includes(site.id)
            ) || [];

            // Set filtered sites to state
            setEntityData({
                ...entity,
                sites: filteredSites
            });
        } catch (error) {
            console.error('Error fetching entity data:', error);
            ErrorToaster('Error fetching sites');
        }
    };

    const handleSiteChange = (siteId) => {
        const site = entityData?.sites?.find(site => site?.id === siteId);
        if (site) {
            const siteData = {
                id: site.id,
                name: site?.siteName?.siteName
            };
            setSelectedSite(siteData);
        }
    };

    const handleContinueClick = async () => {
        if (selectedSite?.id === '0') {
            ErrorToaster('Please select a site to continue');
            return;
        }

        try {
            // Call the parent's handleSelectedSite function with the site data and modal flag
            await handleSelectedSite({
                selectedSite: {
                    id: selectedSite.id,
                    name: selectedSite.name
                },
                reminderType: reminderType || 'TIMESHEET_CREATION_REMINDER',
                showTimesheetModal: true
            });
            handleClose();
        } catch (error) {
            ErrorToaster('Error saving data');
        }
    };

    const availableSites = entityData?.sites?.map(site => ({
        id: site?.id,
        name: site?.siteName?.siteName
    })) || [];

    console.log('availableSites', availableSites);

    const getReminderTypeText = (type) => {
        console.log('Getting text for type:', type);
        switch (type) {
            case 'TIMESHEET_CREATION_REMINDERS':
                return 'Timesheet Creation';
            case 'TIMESHEET_SUBMISSION_REMINDERS':
                return 'Timesheet Submission';
            case 'TIMESHEET_REVIEW_APPROVE_REMINDER':
                return 'Timesheet Review & Approval';
            case 'TIMESHEET_REJECTION_REMINDERS':
                return 'Timesheet Rejection';
            default:
                return 'Timesheet Creation';
        }
    };

    return (
        <Dialog
            isOpen={show}
            onClose={handleClose}
            className={`${style.siteSelectionDialog} ${style.whiteBackground}`}
        >
            <div className={`${Classes.DIALOG_BODY} ${style.margin20}`}>
                <div className={style.spaceBetween}>
                    {isSaveConfirmation ? (
                        <p className={style.extensionStyle}>
                            {`${getReminderTypeText(reminderType)} Notification Alert Trigger Conditions Saved Successfully`}
                        </p>
                    ) : (
                        <p className={style.extensionStyle}>
                            {`Select Site To Setup ${getReminderTypeText(reminderType)} Notification Alerts`}
                        </p>
                    )}
                    <Icon
                        icon="cross"
                        size={20}
                        intent={Intent.DANGER}
                        className={style.addInvocieCrossStyle}
                        onClick={() => handleClose(true)}
                    />
                </div>
                <div className={style.extensionBorder}></div>

                {isSaveConfirmation ? (
                    // Save confirmation view
                    <>
                        <div className={style.saveConfirmationContent}>
                            <p className={style.confirmationText}>
                                {`${getReminderTypeText(reminderType)} Notification Alert Trigger Conditions Saved Successfully`}
                            </p>
                            {/* <p className={style.siteInfo}>{selectedSite?.name}</p> */}
                        </div>
                        <div className={`${style.buttonContainer} ${style.marginTop20}`}>
                            <button
                                className={style.save}
                                onClick={() => {
                                    handleClose();

                                    if (isMultiSiteEntity) {
                                        navigate('/alerts-notifications', {
                                            state: {
                                                view: 'alertsTable',
                                                reminderType: reminderType || 'TIMESHEET_CREATION_REMINDER'
                                            }
                                        });
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </>
                ) : (
                    // Site selection view
                    <>
                        {availableSites.length === 0 ? (
                            <div className={`${style.positionCenter} ${style.marginTop20}`}>
                                <p className={style.noSitesMessage}>No sites available for alerts setup</p>
                            </div>
                        ) : (
                            <CommonSelectField
                                value={selectedSite?.id}
                                onChange={(e) => handleSiteChange(e.target.value)}
                                className={style.fullWidth}
                                firstOptionLabel="Select Site"
                                firstOptionValue="0"
                                valueList={availableSites.map(site => site?.id)}
                                labelList={availableSites.map(site => site?.name)}
                                disabledList={availableSites.map(() => false)}
                            />
                        )}

                        {availableSites.length > 0 && (
                            <div className={`${style.positionCenter} ${style.marginTop20}`}>
                                <button
                                    className={style.continueButton}
                                    onClick={handleContinueClick}
                                    disabled={selectedSite?.id === '0'}
                                >
                                    GO TO SETUP
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </Dialog>
    );
};

export default AddSiteSelectionPopup; 